<template>
  <div class="xiangmu">
    <!--        经销商列表主页-->
    <!--    <breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商列表'}]"/>-->
    <Breadtabsheader/>
    <div class="h-piece h-mrt30">
      <div class="h-formBox hidden">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn" >
            <el-form-item label="　经销商名称">
              <el-input v-model="formInline.usernameInfo" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="　经销商编码">
              <el-input v-model="formInline.usercodeInfo" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="销售区域">
              <brselectlazy category="YlSalesArea_chanpin" :v="formInline.salesregionSell"
                            v-model="formInline.salesregionSell" :clearable="true"/>
            </el-form-item>
            <el-form-item label="　经销商状态">
              <el-select v-model="formInline.statusInfo" :clearable="true">
                <el-option label="正常" value="1"></el-option>
                <el-option label="审批中" value="4"></el-option>
                <el-option label="禁用/冻结" value="0"></el-option>
                <el-option label="申诉中" value="3"></el-option>
                <el-option label="驳回" value="5"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn" >
                <el-form-item label="主销售渠道">
                  <brselectlazy category="sales_region" :v="formInline.customergroup3Sell"
                                v-model="formInline.customergroup3Sell" :clearable="true"/>
                </el-form-item>
                <el-form-item label="直单用户">
                  <el-select v-model="formInline.iszhidanBas" :clearable="true">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="客户类型">
                  <brselectlazy category="agent_type" :v="formInline.agentTypeBas"
                                v-model="formInline.agentTypeBas" :clearable="true"/>
                </el-form-item>
                <el-form-item label="链群">
                  <brselectlazy category="YlGoods_category" :v="formInline.goodsCategoryBas"
                                v-model="formInline.goodsCategoryBas" :clearable="true"/>
                </el-form-item>
              </div>
              <div class="h-thirdColumn w-newColumn" >
                <el-form-item label="经销商类别">
                  <brselectlazy category="DealerCategory_type" :v="formInline.agentLevelBas"
                                v-model="formInline.agentLevelBas" :clearable="true"/>
                </el-form-item>
              </div>
            </div>
          </el-collapse-transition>

          <!-- <div class="h-formBtnOut h-columnCenter">
              <el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
              </el-button>
              <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:1.6rem;"
                      @click="toSign('true')">新增经销商
              </el-button>
          </div> -->
        </el-form>
        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
            </el-button>
            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                       @click="toSign('true')">新增经销商
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-table h-mrt30" v-if="clickActive==1">
      <el-table
              @selection-change="handleSelectionChange"
              :data="agentList"
              style="width: 100%;"
              max-height="430"
              border
      >
        <el-table-column
                type="selection"
                width="45"
                :label="all">
        </el-table-column>
        <el-table-column
                type="index"
                label="#"
                width="40">
        </el-table-column>
        <el-table-column
                prop="usernameInfo"
                label="经销商名称"
                :show-overflow-tooltip="true"
                min-width="180"
        >
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{scope.row.usernameInfo}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
                prop="usercodeInfo"
                label="经销商编码"
                width="110"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{scope.row.usercodeInfo}}
            </div>
          </template>
        </el-table-column>
        <!--                <el-table-column-->
        <!--                        prop="contractendtimeContract"-->
        <!--                        label="到期时间"-->
        <!--                        :show-overflow-tooltip="true"-->
        <!--                        align="center"-->
        <!--                        min-width="120">-->
        <!--                </el-table-column>-->
        <el-table-column
                prop="salesregionSell"
                label="销售区域"
                :show-overflow-tooltip="true"
                align="center"
                width="100">
          <template slot-scope="scope">
            {{scope.row.salesregionSell | dictname('YlSalesArea_chanpin')}}
          </template>
        </el-table-column>
        <!--        <el-table-column
                        prop="customergroup3Sell"
                        label="主销售渠道"
                        :show-overflow-tooltip="true"
                        align="center"
                        min-width="120">
                  <template slot-scope="scope">
                    <div style="text-align: left;">
                      {{scope.row.customergroup3Sell | dictname('sales_region')}}
                    </div>
                  </template>
                </el-table-column>-->

        <!--        <el-table-column
                    prop="customergroup3NotMainSell"
                    label="非主销售渠道"
                    :show-overflow-tooltip="true"
                    align="center"
                    min-width="120">
                  <template slot-scope="scope">
                    <div style="text-align: left;">
                      {{scope.row.customergroup3NotMainSell | dictname('sales_region')}}
                    </div>
                  </template>
                </el-table-column>-->

        <el-table-column
                prop="statusInfo"
                label="状态"
                :show-overflow-tooltip="true"
                align="center"
                width="80">
          <template slot-scope="scope">
            <dictname category="zhuangtai_type" :v="scope.row.statusInfo"/>
          </template>
        </el-table-column>
        <el-table-column
                prop="permitSell"
                label="销售资质"
                align="center"
                width="100">
          <template slot-scope="scope">
            <dictname category="permit_value" :v="scope.row.permitSell"/>
          </template>
        </el-table-column>
        <el-table-column
                prop="agentTypeBas"
                label="客户类型"
                align="center"
                width="90">
          <template slot-scope="scope">
            <dictname category="agent_type" :v="scope.row.agentTypeBas"/>
          </template>
        </el-table-column>
        <el-table-column
                prop="iszhidanBas"
                label="客户性质"
                align="center"
                width="90">
          <template slot-scope="scope">
            <dictname category="iszhidan" :v="scope.row.iszhidanBas"/>
          </template>
        </el-table-column>
        <el-table-column
                prop="cunameSell"
                label="创建人"
                align="center"
                width="80">
          <template slot-scope="scope">
            <dictname category="iszhidan" :v="scope.row.cunameSell"/>
          </template>
        </el-table-column>
        <el-table-column
                prop=" "
                label="扩展下单权限"
                :show-overflow-tooltip="true"
                align="center"
                width="100">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <span v-if="scope.row.isExpandAuthorityBas == 1 && scope.row.agentTypeBas ==1 "> 海外</span>
              <span v-if="scope.row.isExpandAuthorityBas == 1 && scope.row.agentTypeBas ==2 "> 海外</span>
              <span v-else-if="scope.row.isExpandAuthorityBas == 1 && scope.row.agentTypeBas==3"> 国内</span>
              <span v-else></span>
            </div>
          </template>
        </el-table-column>
        <!--        <el-table-column
                        prop="goodsCategoryBas"
                        label="链群"
                        :show-overflow-tooltip="true"
                        align="center"
                        min-width="120">
                  <template slot-scope="scope">
                    <div style="text-align: left;">
                      {{scope.row.goodsCategoryBas | dictname('YlGoods_category')}}
                    </div>
                  </template>
                </el-table-column>-->

        <el-table-column
                prop="agentLevelBas"
                label="经销商类别"
                :show-overflow-tooltip="true"
                align="center"
                min-width="120">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.agentLevelBas == 3">专营商</span>
              <span v-if="scope.row.agentLevelBas == 7">战略合作</span>
              <span v-if="scope.row.agentLevelBas == 6">地市直营商</span>
              <span v-if="scope.row.agentLevelBas == 5">分销商3.0</span>
              <span v-if="scope.row.agentLevelBas == 8">合伙人</span>
              <span v-if="scope.row.agentLevelBas == 2">分销商2.0</span>
              <span v-if="scope.row.agentLevelBas == 4">直单用户</span>
              <span v-if="scope.row.agentLevelBas == 1">一级经销商</span>
            </div>
          </template>
        </el-table-column>
        <!--        <el-table-column
                    prop="oneLevelAgentNameBas"
                    label="对阵经销商"
                    :show-overflow-tooltip="true"
                    align="center"
                    min-width="120">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.agentLevelBas == 2">{{scope.row.oneLevelAgentNameBas}}</span>
                      <span v-else></span>
                    </div>
                  </template>
                </el-table-column>-->
        <el-table-column
                prop="companytypeBas"
                label="公司性质"
                align="center"
                width="120">
          <template slot-scope="scope">
            {{scope.row.companytypeBas}}
          </template>
        </el-table-column>
        <el-table-column
                prop="legalBas"
                label="总经理姓名"
                align="center"
                width="120">
          <template slot-scope="scope">
            {{scope.row.legalBas}}
          </template>
        </el-table-column>
        <el-table-column
                prop="achievementBas"
                label="年度营业规模(万元)"
                align="center"
                width="120">
          <template slot-scope="scope">
            {{scope.row.achievementBas}}
          </template>
        </el-table-column>
        <el-table-column
                prop="personnelNumBas"
                label="销售人员数量"
                align="center"
                width="120">
          <template slot-scope="scope">
            {{scope.row.personnelNumBas}}
          </template>
        </el-table-column>
        <el-table-column
                prop="legalPhoneBas"
                label="总经理联系方式"
                align="center"
                width="120">
          <template slot-scope="scope">
            {{scope.row.legalPhoneBas}}
          </template>
        </el-table-column>
        <el-table-column
                prop="brandBas"
                label="经营其他品牌"
                align="center"
                width="120">
          <template slot-scope="scope">
            {{scope.row.brandBas}}
          </template>
        </el-table-column>

        <el-table-column
                prop="creationDateBas"
                label="创建时间"
                align="center"
                width="100">
        </el-table-column>

        <el-table-column
                prop="validityPeriodDateBas"
                label="有效时间"
                align="center"
                width="100">
        </el-table-column>

        <el-table-column
                prop="exitDateBas"
                label="退出时间"
                align="center"
                width="100">
        </el-table-column>
        <el-table-column
                prop="dqApproval"
                label="当前审批人"
                :show-overflow-tooltip="true"
                align="center"
                width="120">
        </el-table-column>
        <el-table-column label="操作" width="550" fixed="right">
          <template slot-scope="scope">
            <div class="w-caozuo" style="text-align: left;">
              <el-button
                      v-if="(scope.row.statusInfo == 6  || scope.row.statusInfo == 5 )&& scope.row.cucodeBas == _user.usercode"
                      type="text"
                      size="small"
                      @click="editAgent(scope.row)"
                      class="h-tableLink h-btn">
                编辑
              </el-button>
              <el-button
                      v-if="(scope.row.statusInfo == 1 &&
                                    ((superUpdate && scope.row.agentTypeBas != 2) || (isShUpdate && scope.row.agentTypeBas == 2)))
                                       || adminFlag
                                    "
                      type="text"
                      size="small"
                      @click="updateAgent(scope.row)"
                      class="h-tableLink h-btn">
                修改
              </el-button>
              <el-button
                      type="text"
                      size="small"
                      @click="checkDetail(scope.row)"
                      class="h-tableLink h-btn">
                查看
              </el-button>
              <el-button
                      type="text"
                      size="small"
                      @click="showHistory(scope.row)"
                      class="h-tableLink h-btn">
                记录
              </el-button>
              <el-button
                      v-show="scope.row.statusInfo != 0 && scope.row.statusInfo != 4 && scope.row.statusInfo != 6 && isdj"
                      type="text"
                      size="small"
                      class="h-tableLink h-btn"
                      @click="freeze(scope.row)">
                冻结
              </el-button>
              <el-button size="small" class="h-tableLink h-btn" type="text" @click="unfreeze(scope.row)" v-if="!quyuFlag"
                         v-show="scope.row.statusInfo == 0">解冻
              </el-button>
            <!--  <el-button size="small"
                         v-if="quyuFlag"
                         type="text"
                         @click="freezeDataupdateAgent(scope.row)"
                         class="h-tableLink h-btn"
                         v-show="scope.row.statusInfo == 0">解冻
              </el-button>-->
              <el-button size="small" class="h-tableLink h-btn" type="text" @click="shenpi(scope.row.instidThawBas)"
                         v-show="scope.row.isThawBas == 1">解冻跟踪
              </el-button>
              <el-button size="small" class="h-tableLink h-btn" type="text"
                         @click="shenpi(scope.row.instidInfo)"
                         v-show="scope.row.instidInfo">跟踪
              </el-button>
              <!--经销商状态正常,并且不是区域经理显示履约解冻按钮-->
              <el-button size="small" class="h-tableLink h-btn" type="text"
                         v-if="(scope.row.statusInfo == 1 && $store.getters.hasRole('swyl_wanglgly')) || (scope.row.statusInfo == 1 && $store.getters.hasRole('swyl_admin'))
                                                                          || (scope.row.statusInfo == 1 && $store.getters.hasRole('swyl_quyujl'))"

                         @click="complianceRelease(scope.row)">履约解冻
              </el-button>
              <!--查看评分表-->
              <el-button size="small" class="h-tableLink h-btn" type="text"
                         v-if="(scope.row.agentLevelBas == 1 || scope.row.agentLevelBas == 3 || scope.row.agentLevelBas == 5 || scope.row.agentLevelBas == 6) && scope.row.agentTypeBas == 1"
                         @click="pingfen(scope.row)">引入评估
              </el-button>
              <el-button size="small" class="h-tableLink h-btn" type="text" v-auth="'network_diagnostics_skip'"
                         v-if="scope.row.agentLevelBas == 1 && '3' != scope.row.agentTypeBas && '1' == scope.row.wlzd" @click="networkDiagnosis(scope.row)">网络诊断
              </el-button>

            </div>
            <!-- <div class="l-operationBox">
                <span class="l-operationlist br-operation-xg" v-if="superUpdate && scope.row.statusInfo == 1" title="修改" @click="updateAgent(scope.row)"></span>
                <span class="l-operationlist br-operation-look" title="查看" @click="checkDetail(scope.row)"></span>
                <span class="l-operationlist br-operation-dj" v-show="scope.row.statusInfo != 0" title="冻结" @click="freeze(scope.row)"></span>
                <span class="l-operationlist br-operation-jd" v-show="scope.row.statusInfo == 0" title="解冻" @click="unfreeze(scope.row)"></span>
                <span class="l-operationlist br-operation-spgz" v-show="scope.row.statusInfo == 4" title="审批跟踪" @click="shenpi(scope.row.instidInfo)"></span>
            </div> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="left">
        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                   @click="exportExcel" v-if="!isShield">批量导出
        </el-button>
        <!--				<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"-->
        <!--							@click="daoru">批量导入-->
        <!--				</el-button>-->
        <pagination :page="q" @query="choose"/>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible2" width="53%" class="h-dialog3 dialogFormVisible3">
      <div class="h-dialogImg">
        <div style="display:flex;align-items:center;">
          <img src="../../../assets/images/daoru-j.png" alt="" style="width: 86px;height: 86px;">
          <div>
            <p class="piliang1">批量导入</p>
            <p class="piliang2">导入文件请先下载模版并按照模版填写完成后，点击上传文件，上传文件不大于200M</p>
          </div>
        </div>

        <div class="piliangBox">
          <div class="imgs"><img src="../../../assets/images/daoru-exls.png" alt=""
                                 style="width: 40px;height: 39px;"></div>
          <div class="imgs">批量导入模版文件.xlsx</div>
          <div class="imgs" style="color: #0865c4;cursor:pointer;">下载</div>
        </div>
        <!--<div style="width:100%;">
            <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    style="width:100%;">
                <div style="width:100%;">+ 上传文件</div>
            </el-upload>
        </div>-->
        <div style="display:flex;justify-content:center;margin-top:30px;">
          <el-button class="h-btn h-formBtn h-bgwhite" type="primary" @click="dialogFormVisible2 = false">
            取消
          </el-button>
          <el-button class="h-btn h-formBtn" type="primary" style="margin-left:40px;"
                     @click="dialogFormVisible2 = false">提交
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="centerDialogVisible" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>解冻</h1>
            <p>Unfreeze</p>
          </div>
        </div>
      </div>
      <div class="h-formLine h-mrb-38" style="margin: 0.38rem 0 0 0;">
        <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem;margin-left: 30px" v-if="quyuFlag || adminFlag">*
          经销商因合同过期冻结,合同审批通过后自动解冻,无需发起解冻申请!
        </div>
        <el-form :inline="true" :model="freezeData" class="demo-form-inline h-formBorder"
                 style="margin-top: 0.4rem">
          <el-form-item label="到期日调整" class="h-elformWrap-2" style="margin-left:0.5rem;">
            <el-date-picker type="date" placeholder="选择时间" value-format="yyyy-MM-dd" v-model="freezeData.timeData"
                            :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
          <el-form-item label="解冻原因" class="h-elformWrap-2" style="margin-left:0.5rem;">
            <el-input type="textarea" v-model="freezeData.reason" :clearable="true" style="margin-left:0.1rem;"></el-input>
          </el-form-item>
          <br>
          <el-form-item label="上传附件" class="h-elformWrap-2" style="margin-left:0.5rem;">
            <brupload
                    :refid="refid"
                    reftype="代理商修改-解冻附件"
                    uploadflag
                    delflag
                    :showtime="false"
            >
            </brupload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="checkUnFreeze">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="centerDialogVisible1" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>延期</h1>
            <p>PostPone</p>
          </div>
        </div>
      </div>
      <div class="h-formLine " style="margin: 0.38rem 0 0 0;">
        <el-form :inline="true" :model="freezeData" class="demo-form-inline h-formBorder"
                 style="margin-top: 0.4rem">
          <el-form-item label="到期日调整" style="margin-left:2rem;">
            <el-col :span="11">
              <el-date-picker type="date" placeholder="选择时间" v-model="freezeData.timeData"
                              :picker-options="pickerOptions"></el-date-picker>
            </el-col>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="checkPostpone">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
            title=""
            :visible.sync="dialogVisiblehis"
            :fullscreen="false"
            width="70%"
            :modal="true"
            :before-close="handleClose" class="h-dialog2">
      <!--<div class="h-formbLine yhelformitem" style="margin-bottom: 0.1rem;display: flex;align-items: center;">
          <el-form :inline="true" :model="mf" class="demo-form-inline h-formBorder">
              <el-form-item label="更新节点">
                  <brselect
                          category="loud_node"
                          :v="mf.changeNode"
                          v-model="mf.changeNode"
                          clearable>
                  </brselect>
              </el-form-item>
              <el-form-item label="预测单号" v-if="false">
                  <el-input v-model="q.loudId"></el-input>
              </el-form-item>
              <el-form-item label="标识" v-if="false">
                  <el-input v-model="q.del"></el-input>
              </el-form-item>
              &lt;!&ndash; <el-form-item class="h-formBtnOut" style="margin-top:-11px;width:40%;">

               </el-form-item> &ndash;&gt;
          </el-form>
          <div style="margin-top: -0.2rem;margin-left: 0.2rem;">
              <el-button class="h-btn h-formBtn" @click="handleMessage">搜索</el-button>
              <el-button class="h-btn h-formBtn" @click="resetMsg"
                         style="background-color:white;color:black;border:1px solid #d1d1d1">重置
              </el-button>
          </div>
      </div>-->
      <h3>&nbsp;</h3>
      <div class="tanBox">
        <el-table
                :data="tableDatahi"
                border
                max-height="420"
                style="width: 94%; margin:0 auto;">
          <el-table-column
                  type="index"
                  width="45"
                  label="#">
          </el-table-column>
          <el-table-column
                  prop="userCode"
                  label="经销商编码"
                  width="100"
                  :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
                  prop="userName"
                  label="经销商名称"
                  width="110"
                  :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
                  prop="operateField"
                  label="修改字段"
                  width="110"
                  :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
                  prop="operateOld"
                  label="修改前内容"
                  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: left;">{{scope.row.operateOld}}</div>
            </template>
          </el-table-column>
          <el-table-column
                  prop="operateValue"
                  label="修改后内容"
                  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: left;">{{scope.row.operateValue}}</div>
            </template>
          </el-table-column>
          <el-table-column
                  prop="operateTime"
                  label="操作时间"
                  width="160"
                  :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
                  prop="cuname"
                  label="修改人"
                  width="100"
                  :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
                  prop="reason"
                  label="履约解冻原因"
                  width="100"
                  :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="履约解冻附件" class="h-elformWrap-2" width="250" prop="upload">
            <template slot-scope="scope">
              <brupload :refid="scope.row.refid" style="" align="center" reftype="代理商修改-解冻附件"
                        :delflag="false" :showtime="false" :uploadflag="false"
              >
              </brupload>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="display:flex;justify-content: flex-end;align-items:center;margin-top:20px">
        <paginationmin :page="mf" @query="handleMessage"/>
      </div>
    </el-dialog>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    <!--查看评分表-->
    <viewscoretable :visible.sync="showscoretable" v-if="showscoretable"  @choseObj="getChoose" :usercodeInfo="usercodeInfo" :instid="instid"/>
    <!--查看评分表结束-->
    <!--    履约解冻弹窗开始-->
    <el-dialog :close-on-click-modal="false" class="new-dialog" :visible.sync="dialogFormVisible" width="300">
      <!-- dialogImg -->
      <div class="h-dialogImg">
        <h3>履约解冻</h3>
      </div>
      <el-form  ref="complianceReleaseFrom" label-width="120px" size="mini"
                class="addDeliveryForm clearfix">

        <div style="float: left;width: 100%;" >
          <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
            <h1>数智样本</h1>
          </div>
          <el-form-item v-for="(item, index) in lyjdArrC1" :label="item.name" prop="item.lq" :key="index+item.name+item.fieldLq"
                        style='width: 33%;float: left;'>
            <el-switch
                    v-model="item.frozenStatus"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0">
            </el-switch>
          </el-form-item>
        </div>
        <div style="float: left;width: 100%;" >
          <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
            <h1>数智医疗</h1>
          </div>
          <el-form-item v-for="(item, index) in lyjdArrC3" :label="item.name" prop="item.lq" :key="index+item.name"
                        style='width: 33%;float: left;'>
            <el-switch
                    v-model="item.frozenStatus"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0">
            </el-switch>
          </el-form-item>
        </div>
        <div style="float: left;width: 100%;" >
          <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
            <h1>数智科研</h1>
          </div>
          <el-form-item v-for="(item, index) in lyjdArrC4" :label="item.name" prop="item.lq" :key="index+item.name"
                        style='width: 33%;float: left;'>
            <el-switch
                    v-model="item.frozenStatus"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0">
            </el-switch>
          </el-form-item>
        </div>
        <div style="float: left;width: 100%;" >
          <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
            <h1>血液网</h1>
          </div>
          <el-form-item v-for="(item, index) in lyjdArrC5" :label="item.name" prop="item.lq" :key="index+item.name"
                        style='width: 33%;float: left;'>
            <el-switch
                    v-model="item.frozenStatus"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0">
            </el-switch>
          </el-form-item>
        </div>
        <div style="float: left;width: 100%;" >
          <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
            <h1>血液网-传统</h1>
          </div>
          <el-form-item v-for="(item, index) in lyjdArrC7" :label="item.name" prop="item.lq" :key="index+item.name"
                        style='width: 33%;float: left;'>
            <el-switch
                    v-model="item.frozenStatus"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0">
            </el-switch>
          </el-form-item>
        </div>
        <div style="float: left;width: 100%;" >
          <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
            <h1>朗康-传统</h1>
          </div>
          <el-form-item v-for="(item, index) in lyjdArrC8" :label="item.name" prop="item.lq" :key="index+item.name"
                        style='width: 33%;float: left;'>
            <el-switch
                    v-model="item.frozenStatus"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0">
            </el-switch>
          </el-form-item>
        </div>
      <!--  <div style="float: left;width: 100%;" >
          <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
            <h1>暂无签约</h1>
          </div>
          <el-form-item v-for="(item, index) in lyjdArrZWQY" :label="item.name" prop="item.lq" :key="index+item.name"
                        style='width: 33%;float: left;'>
            <el-switch
                    v-model="item.frozenStatus"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0">
            </el-switch>
          </el-form-item>
        </div>-->
        <div style="float: left">
          <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
            <h1>履约解冻</h1>
          </div>
          <el-form-item v-for="(item, index) in lyjdArr" :label="item.name" prop="item.lq" :key="index+item.name"
                        style='width: 33%;float: left;'>
            <el-switch
                    v-model="item.frozenStatus"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0">
            </el-switch>
          </el-form-item>
        </div>
        <dev style="float: left">
          <div style="float: left">
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
              <h1>附件</h1>
            </div>
            <el-form-item label="上传附件" class="h-elformWrap-2" style="margin-left:0.5rem;">
              <brupload
                      :refid="refid"
                      reftype="代理商修改-解冻附件"
                      uploadflag
                      delflag
                      :showtime="false"
              >
              </brupload>
            </el-form-item>
          </div>
        </dev>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="()=>dialogFormVisible=false">取 消</el-button>
        <el-button class="h-btn h-bBtn" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <!--    履约解冻弹窗结束-->
  </div>
</template>
<script>
  import agentCopyService from "../../../api/loud/agent/agentCopyService";
  import util from "../../../utils/util";
  import updownfile from '../../../utils/updownfile';

  export default {
    data() {
      return {
        pingtairole:false,
        dialogFormVisible: false,//履约解冻弹窗开关
        lyjdArr:[],//履约解冻对象
        lyjdArrL1:[],//履约解冻对象 领域医疗创新领域
        lyjdArrL2:[],//履约解冻对象 领域生命科学领域
        lyjdArrC1:[],//履约解冻对象 超低温&低温&冻干机		X02  数智样本 X02,X06,X16
        lyjdArrC2:[],//履约解冻对象 疫苗网		X06
        lyjdArrC3:[],//履约解冻对象 数智医疗		X01
        lyjdArrC4:[],//履约解冻对象 数智科研		X08,X09,X10
        lyjdArrC5:[],//履约解冻对象 血液网		X05
        lyjdArrC7:[],//履约解冻对象 血液网传统
        lyjdArrC8:[],//履约解冻对象 朗康传统
        lyjdArrZWQY:[],//履约解冻对象 暂无签约
        adminFlag:false,
        quyuFlag:false,
        // 展开折叠筛选
        isScreen:false,
        closeScreen:require("@/assets/images/pimg/closeallic.png"),
        drawScreen:require("@/assets/images/pimg/dobleArr.png"),
        superUpdate: false,
        isShUpdate: false,
        isdj:true,
        showscoretable: false,
        instid: '',
        usercodeInfo:'',
        bscUserInfoAgent:"",
        showhistory: false,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now();
          },
        },
        dialogFormVisible2: false,
        updateEndTime: {
          customerCode: null,
          contractEndtime: null
        },
        freezeData: {
          timeData: null,
          allData: null,
          reason: null,
        },
        updateData: {
          usercode: null,
          status: null
        },
        agentList: [],
        tableDatahi: [],
        centerDialogVisible: false,
        centerDialogVisible1: false,
        dialogVisiblehis:false,
        isShield:false,//法务屏蔽导出
        //表单
        dataList: [
          {name: "哈哈"},
          {name: "呵呵"},
          {name: "晓丽"},
          {name: "小兰"},
          {name: "财务"},
          {name: "嘻嘻"},
          {name: "测试"}],
        list: [],
        input_value: "",
        state: false,

        all: '全部',
        formInline: {
          usernameInfo: null,
          salesregionSell: null,
          customergroup3Sell: null,
          customergroup3NotMainSell:null,
          statusInfo: null,
          customergroupSell: null,
          agentTypeBas: null,
          goodsCategoryBas: null,
          pageSize: 10,
          pageNo: 1,
          agentLevelBas:null,
        },
        refid: this.$util.getUuid(),
        usercodelq:null,

        //表格
        multipleSelection: [],

        clickActive: 1,
        q: {
          pageSize: 10,
          pageNo: 1,
          total: 0
        },
        mf: {
          pageSize: 10,
          pageNo: 1,
          total: 0,
        },
        data: {
          index: null,
          isFreezeData:null
        },
        isCheck: null,
        areaList:{},
        areaLq:'',
      }
    },
    created() {
      let diagnostics =  this.$store.getters.dicts['network_diagnostics']||[];
      if (null !== diagnostics && diagnostics.length > 0){
        for (let i = 0; i < diagnostics.length; i++) {
          let flag = false;
          for (let j = 0; j < this._user.roles.length; j++) {
            if (diagnostics[i].name.indexOf(this._user.roles[j].id) !== -1){
              this.pingtairole = true;
              flag = true;
              break;
            }
          }
          if (flag){
            break;
          }
        }
      }
      //查询当前登录用户对应区域的经销商列表
      this.query();
      // 给管理员和尚伟以及销售经理赋权不经过审批修改经销商信息按钮  区域经理也可以有这个权限 区域经理会走审批流
      for (var i = 0; i < this.$store.getters.roles.length; i++) {
        if (this.$store.getters.roles[i].id == 'swyl_wanglgly' || this.$store.getters.roles[i].id == 'swyl_admin'
                || this.$store.getters.roles[i].id == 'swyl_quyujl' || this.$store.getters.roles[i].id == 'swyl_xiaoshoujl_wx'
                || this.$store.getters.roles[i].id == 'swyl_xiaoshoujl_honghu' || this.$store.getters.roles[i].id == 'swyl_agent_update'
                || this.$store.getters.roles[i].id == 'swyl_xiaoshoujl_kangsheng' || this.$store.getters.roles[i].id == 'hh_shichangneiqin'
                || this.$store.getters.roles[i].id == 'swyl_xiaoshoujl_yx' || this.$store.getters.roles[i].id == 'swyl_xiaoshoujl_yx_wx'
                || this.$store.getters.roles[i].id == 'yx_xiaoshouzongjian_w' || this.$store.getters.roles[i].id == 'yx_shouhoujl'

        ){
          this.superUpdate = true;
        }
      }
      this.isShUpdate = this.$store.getters.hasRole("swyl_admin,shzxcaigoujingli,swyl_shanghailq_xiaoweizhu,swyl_shanghai_caiwu,swyl_xiaoshoujl_shanghai,swyl_xsyb_gly_sh,hh_shichangneiqin");
      this.adminFlag = this.$store.getters.hasRole('swyl_admin');
      this.isdj = !this.$store.getters.hasRole('swyl_quyujl,swyl_xiaoshoujl_kangsheng,swyl_xiaoshoujl_yx,swyl_xiaoshoujl_yx_wx,yx_shouhoujl');
      this.quyuFlag = this.$store.getters.hasRole('swyl_quyujl');
      this.isShield = this.$store.getters.hasRole('swyl_fawu');
    },
    activated(){
      this.checkData();
    },
    beforeRouteLeave(to, from, next) {
      from.meta.keepAlive = false;
      next();
    },
    methods: {
      //关闭弹出框
      handleClose(v) {
        this.mf.userCode = '';
        this.mf.pageNo =  1;
        v()
      },
      handleMessage() {
        agentCopyService.selectMsgPage(this.mf).then(rd => {
          this.mf.total = rd.total;
          this.tableDatahi = rd.records;
        })
      },
      showHistory(v){
        var m = {
          pageSize: 10,
          pageNo: 1,
          userCode: v.usercodeInfo
        }
        agentCopyService.selectMsgPage(m).then(rd => {
          this.mf.total = rd.total;
          this.tableDatahi = rd.records;
          this.mf.userCode = v.usercodeInfo;
          this.dialogVisiblehis = true;
        })
      },
      // 展开折叠
      collapseChange(){
        this.isScreen = !this.isScreen;
      },
      updateAgent(v){
        this.data = v;
        this.data.index = '2';
        this.data.typeOpr = 'xiuGai'
        this.$router.push({path: '/agentUpdateShangWei', query: this.data});
      },
      freezeDataupdateAgent(v){
        this.data = v;
        this.data.index = '2';
        this.data.isFreezeData = '1';
        this.data.typeOpr = 'xiuGai'
        this.$router.push({path: '/agentUpdateShangWei', query: this.data});
      },
      shenpi(v) {
        console.log(v, 'instid')
        this.instid = v;
        this.showhistory = true;

      },
      exportExcel() {
        var idlist = [];
        this.multipleSelection.forEach(element => {
          idlist.push(element.usercodeInfo);
        });
        if(idlist.length>0){
          updownfile.down("/api/swyl/v1/viewagentlist/viewAgentList/downloadExcel", idlist, "post", 'data');
        }else{
          updownfile.down("/api/swyl/v1/viewagentlist/viewAgentList/downloadYExcel", this.formInline, "post");
        }

      },
      daoru() {
        this.dialogFormVisible2 = true;
      },
      // 延期按钮确认
      checkPostpone() {
        //更新到期时间
        this.updateEndTime.customerCode = this.freezeData.allData.usercodeInfo;
        this.updateEndTime.contractEndtime = util.riQi3(this.freezeData.timeData);
        console.log(this.updateEndTime, 'aaaaaaaaaa')
        agentCopyService.updateEndTime(this.updateEndTime);
        this.query();
        this.centerDialogVisible1 = false;
        this.$message({
          type: 'success',
          message: '延期成功!'
        });
      },
      //解冻确认按钮
      checkUnFreeze() {
        //更新到期时间
        let query = {
          usercode: this.freezeData.allData.usercodeInfo,
          customerName1: this.freezeData.allData.usernameInfo,
          isFrozen: '1',//是否是手动设置经销商到期日
          validityPeriodDate: this.freezeData.timeData,
          reason:this.freezeData.reason,
          refid: this.refid,
          region: this.freezeData.allData.regionBas,
          isZhidan: this.freezeData.allData.iszhidanBas,
          isThaw: this.freezeData.allData.isThawBas
        };

        if(!this.quyuFlag){
          agentCopyService.agentThaw(query).then(rd => {
            console.log("rdedede ",rd)
            if(rd.f){
              //更新经销商状态
              this.updateData.usercode = this.freezeData.allData.usercodeInfo;
              this.updateData.status = "1";
              agentCopyService.update(this.updateData);
              //this.query();
              this.checkData();
              this.centerDialogVisible = false;
              this.$message({
                type: 'success',
                message: '解冻成功!'
              });
            }
          });
        }else {
          agentCopyService.agentThawQY(query).then(rd => {
            console.log("rdedede ",rd)
            if(rd.f){
              //更新经销商状态
              this.updateData.usercode = this.freezeData.allData.usercodeInfo;
              this.updateData.status = "1";
              //this.query();
              this.checkData();
              this.centerDialogVisible = false;
              this.$message({
                type: 'success',
                message: '提交成功!'
              });
            }
          });
        }
      },
      //冻结按钮功能
      freeze(v) {
        console.log(v, 'v')
        if (v.statusInfo !== "0") {
          this.$confirm('此操作将冻结该经销商, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.updateData.usercode = v.usercodeInfo;
            this.updateData.status = "0";
            agentCopyService.update(this.updateData);
            let query = {
              usercode: v.usercodeInfo,
              customerName1: v.usernameInfo,
            };
            agentCopyService.agentOperate(query);
            // this.query();
            this.checkData();
            this.$message({
              type: 'success',
              message: '冻结成功!'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消冻结'
            });
          });
        } else {
          this.$message({
            type: 'error',
            message: '该经销商已被冻结!请勿重复操作'
          });
        }

      },
      choose1() {
        this.$alert("测试", '提示', {
          confirmButtonText: '确定',
          type:'warning',
          callback: action => {
            updownfile.down('/api/swyl/v1/agent/bscUserInfoAgent/getExcel',"post");
          }
        });
      },
      //点击分页调用方法判断
      choose() {
        if (this.isCheck) {
          this.checkData();
        } else {
          this.query();
        }
      },
      //重置按钮功能
      resetData() {
        this.formInline.usernameInfo = '';
        this.formInline.usercodeInfo = '';
        this.formInline.salesregionSell = '';
        this.formInline.customergroup3Sell = '';
        this.formInline.statusInfo = '';
        this.formInline.customergroupSell = '';
        this.formInline.iszhidanBas = '';
        this.formInline.agentTypeBas = '';
        this.formInline.goodsCategoryBas = '';
        this.formInline.pageSize = 10;
        this.formInline.pageNo = 1;
        this.formInline.agentLevelBas = null;
        this.query();
      },
      //检索按钮功能
      checkData() {
        this.isCheck = true;
        this.formInline.pageNo = this.q.pageNo;
        this.formInline.pageSize = this.q.pageSize;
        console.log(this.formInline, 'forminline')
        agentCopyService.check(this.formInline).then(response => {
          console.log(response, 'response')
          this.agentList = response.records;
          this.q.total = response.total;
        })
      },
      //审批按钮功能
      approve(v) {
        this.data = v;
        this.data.index = '3';
        this.$router.push({path: '/agentDetail', query: this.data});
      },
      //查看按钮功能
      checkDetail(v) {
        console.log(v)
        this.data = v;
        this.data.index = '2';
        this.$router.push({path: '/agentDetail', query: this.data});
      },
      editAgent(v) {
        this.data = v;
        this.data.index = '2';
        this.$router.push({path: '/agentDetail', query: this.data});
      },
      //延期按钮功能
      postpone(v) {
        this.centerDialogVisible1 = true;
        this.freezeData.allData = v;
      },
      //解冻按钮功能
      unfreeze(v) {
        console.log(v);
        if (v.statusInfo === "0") {
          this.centerDialogVisible = true;
          this.freezeData.allData = v;
          this.freezeData.reason = '';
          this.freezeData.timeData = '';
          this.refid = this.$util.getUuid();
        } else {
          this.$message({
            type: 'error',
            message: '该经销商没有被冻结!无需解冻'
          });
        }

      },
      //转到新增页面
      toSign() {
        this.data.index = '1';
        this.$router.push({path: '/agentDetail', query: this.data});
      },
      //查询当前登录用户对应区域的经销商列表
      query() {
        this.isCheck = false;
        agentCopyService.query(this.q).then(response => {
          console.log(response, 'response')
          this.q.total = response.total;
          this.agentList = response.records;
          // for (var i=0;i<this.agentList.length;i++){
          // 	this.agentList[i].statusInfo=this.$getDictName('zhuangtai_type',this.agentList[i].statusInfo);
          // }
        })
      },
      //表格
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      dianji() {
        if (item) {
          this.input_value = v.name;

          this.state = false
        }
      },
      throttle() {
        console.log(this.input_value)
        this.dataList.forEach(v => {
          if (this.input_value == v.name) {
            this.state = true;

          }
        })

      },
      // 延期弹窗
      createdemand() {
        this.dialogFormVisible1 = true;
      },
      lineChart() {
        let lineChart = this.$echarts.init(document.getElementById('h_lineChart'));
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              show: true,
              lineStyle: {
                width: 1,
                color: '#61a0f7'
              }
            }
          },
          legend: {
            show: false
          },
          calculable: true,

          yAxis: [{
            type: 'value',
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            }
          }],
          series: [{
            name: '跑步排名',
            type: 'line',
            symbol: 'circle',
            symbolSize: 0,
            showSymbol: false,
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(145,188,250,1)' // 0% 处的颜色
                }, {
                  offset: 0.5, color: 'rgba(145,188,250,0.5)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(145,188,250,0)' // 100% 处的颜色
                }],
                globalCoord: false // 缺省为 false
              },
            },
            smooth: true,
            data: [30, 58, 98, 52, 68, 30, 88],
            lineStyle: {
              color: '#61a0f7'
            },
            itemStyle: {
              normal: {
                color: '#ffffff',
                borderColor: '#61a0f7',
                borderWidth: 2
              }
            }
          }
          ]
        };
        lineChart.setOption(option);
      },
      //点击履约解冻
      complianceRelease(row) {
        //获取区域
        if (!row.usercodeInfo) return
        this.dialogFormVisible = true;
        this.refid = this.$util.getUuid();
        this.usercodelq = row.usercodeInfo;
        // this.lyjdArr =  object
        //获取履约解冻 数据
        let query = {
          usercode:row.usercodeInfo,
        }
        agentCopyService.queryLq(query).then(rd => {
          if (!rd || rd.length === 0) {
            this.$message.info('未查询到相关履约解冻信息.')
          }
          let arr = []
          let arrC1 = []
          let arrC2 = []
          let arrC3 = []
          let arrC4 = []
          let arrC5 = []
          let arrC7 = []
          let arrC8 = []
          let arrZWQY = []
          if (rd.length > 0) {
            for (let item of rd) {
              let obj = {};
              obj.id = item.id;
              obj.lq = item.lq;
              obj.frozenStatus = item.frozenStatus;//o:冻结  1 解冻
              obj.fieldLq = item.fieldLq;//领域
              if (item.lq == 'X06') {
                obj.name = '疫苗网';
              } else if (item.lq == 'X05') {
                obj.name = '血液网';
              } else if (item.lq == 'X07') {
                obj.name = '试剂网';
              } else if (item.lq == 'X02') {
                obj.name = '样本网';
              } else if (item.lq == 'X08') {
                obj.name = '生物安全类';
              } else if (item.lq == 'X01') {
                obj.name = '药品网';
              } else if (item.lq == 'X09') {
                obj.name = '培养箱类';
              }else if (item.lq == 'X10') {
                obj.name = '离心机';
              }else if (item.lq == 'X12') {
                obj.name = '航空温控';
              }else if (item.lq == 'X11') {
                obj.name = '危化品';
              }else if (item.lq == 'X13') {
                obj.name = '康盛';
              }else if (item.lq == 'X04') {
                obj.name = '海盛杰';
              }else if (item.lq == 'X14') {
                obj.name = '厚宏';
              }else if (item.lq == 'X15') {
                obj.name = '元析';
              }else if (item.lq == 'X16') {
                obj.name = '超低温&低温&冻干机';
              }
              if(item.fieldLq == 'C1'){
                arrC1.push(obj)
              }else if(item.fieldLq == 'C2'){
                arrC1.push(obj)
              }else if(item.fieldLq == 'C3'){
                arrC3.push(obj)
              }else if(item.fieldLq == 'C4'){
                arrC4.push(obj)
              }else if(item.fieldLq == 'C5'){
                arrC5.push(obj)
              }else if(item.fieldLq == 'C7'){
                arrC7.push(obj)
              }else if(item.fieldLq == 'C8'){
                arrC8.push(obj)
              }else if(item.fieldLq == '暂无签约'){
                arrZWQY.push(obj)
              }else if(item.lq == 'X02'){
                arrC1.push(obj)
              }else{
                arr.push(obj);
              }
            }
          }
          this.lyjdArr = arr;
          this.lyjdArrC1 = arrC1;
          this.lyjdArrC2 = arrC2;
          this.lyjdArrC3 = arrC3;
          this.lyjdArrC4 = arrC4;
          this.lyjdArrC5 = arrC5;
          this.lyjdArrC7 = arrC7;
          this.lyjdArrC8 = arrC8;
          this.lyjdArrZWQY = arrZWQY;
        })
      },
      pingfen(row){
        console.log("row",row);
        this.usercodeInfo = row.usercodeInfo;
        this.instid = row.instidInfo;
        this.showscoretable = true;
      },
      networkDiagnosis(row){
        //网络诊断页面跳转
        console.log(row.usercodeInfo)
        let query = {
          agentCode: row.usercodeInfo
        }
        this.$router.push({path: '/dashboard', query: query});
      },
      getChoose(obj){
        this.showscoretable = obj.showscoretable;
      },
      changeArea(event){
        console.log(event);
        //获取履约解冻 数据
        let query = {
          usercode:this.usercodelq,
          area:event.name
        }
        agentCopyService.queryLq(query).then(rd => {
          if (!rd || rd.length === 0) {
            this.$message.info('未查询到相关履约解冻信息.')
          }
          let arr = []
          let arrL1 = []
          let arrL2 = []
          if (rd.length > 0) {
            for (let item of rd) {
              let obj = {};
              obj.id = item.id;
              obj.lq = item.lq;
              obj.frozenStatus = item.frozenStatus;//o:冻结  1 解冻
              obj.fieldLq = item.fieldLq;//领域
              if (item.lq == 'X06') {
                obj.name = '疫苗网';
              } else if (item.lq == 'X05') {
                obj.name = '血液网';
              } else if (item.lq == 'X07') {
                obj.name = '试剂网';
              } else if (item.lq == 'X02') {
                obj.name = '样本网';
              } else if (item.lq == 'X08') {
                obj.name = '生物安全类';
              } else if (item.lq == 'X01') {
                obj.name = '药品网';
              } else if (item.lq == 'X09') {
                obj.name = '培养箱类';
              }else if (item.lq == 'X10') {
                obj.name = '离心机';
              }else if (item.lq == 'X12') {
                obj.name = '航空温控';
              }else if (item.lq == 'X11') {
                obj.name = '危化品';
              }else if (item.lq == 'X13') {
                obj.name = '康盛';
              }else if (item.lq == 'X04') {
                obj.name = '海盛杰';
              }
              if(item.fieldLq == 'L1'){
                arrL1.push(obj)
              }else if(item.fieldLq == 'L2'){
                arrL2.push(obj)
              }else{
                arr.push(obj);
              }
            }
          }
          this.lyjdArr = arr;
          this.lyjdArrL1 = arrL1;
          this.lyjdArrL2 = arrL2;
        })
      },
      //履约解冻 提交
      submit() {
        if (this.lyjdArr.length === 0 && this.lyjdArrC1.length === 0 && this.lyjdArrC2.length === 0) return
        let arr = []
        for (let item of this.lyjdArr) {
          let obj = {};
          obj.id = item.id;
          obj.frozenStatus = item.frozenStatus;
          arr.push(obj);
        }
        for (let item of this.lyjdArrC1) {
          let obj = {};
          obj.id = item.id;
          obj.frozenStatus = item.frozenStatus;
          arr.push(obj);
        }
        for (let item of this.lyjdArrC2) {
          let obj = {};
          obj.id = item.id;
          obj.frozenStatus = item.frozenStatus;
          arr.push(obj);
        }
        for (let item of this.lyjdArrC3) {
          let obj = {};
          obj.id = item.id;
          obj.frozenStatus = item.frozenStatus;
          arr.push(obj);
        }
        for (let item of this.lyjdArrC4) {
          let obj = {};
          obj.id = item.id;
          obj.frozenStatus = item.frozenStatus;
          arr.push(obj);
        }
        for (let item of this.lyjdArrC5) {
          let obj = {};
          obj.id = item.id;
          obj.frozenStatus = item.frozenStatus;
          arr.push(obj);
        }
        for (let item of this.lyjdArrC7) {
          let obj = {};
          obj.id = item.id;
          obj.frozenStatus = item.frozenStatus;
          arr.push(obj);
        }
        for (let item of this.lyjdArrC8) {
          let obj = {};
          obj.id = item.id;
          obj.frozenStatus = item.frozenStatus;
          arr.push(obj);
        }

        //提交履约解冻 数据
        agentCopyService.bscUserInfoLqUpdate(arr,this.refid).then(rd => {
          if (rd.f) {
            this.$message.success(rd.msg)
          } else {
            this.$message.error(rd.msg)
          }
          this.dialogFormVisible = false;
          agentCopyService.check(this.formInline).then(response => {
            console.log(response, 'response')
            this.agentList = response.records;
            this.q.total = response.total;
          })
        })
      },
    },

  }
</script>
<style scoped>
  .left {
    margin-top: 20px;
  }

  .xuqiuBoxList .xuqiulist {
    width: 200px;
    height: 62px;
    border-radius: 4px;
    background: #fff;
    border: 1px solid #959595;
    text-align: center;
    line-height: 62px;
    color: #989898;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
  }

  .xuqiuBoxList .xuqiulist:first-child {
    margin-left: 0
  }

  .xuqiuBoxList .xuqiulist.active {
    background: #238cfd;
    border: 1px solid #238cfd;
    color: #fff;
  }

  .xuqiutext {
    color: #bcbcbc;
    font-size: 14px;
    margin-bottom: 14px;
  }

  .xuqiuBoxList {
    width: 100%;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
  }

  .ul {
    position: absolute;
    background: #fff;
    padding: 5px 10px 5px 10px;
    z-index: 9;
    height: 100px;
    overflow-y: auto;
    text-align: center
  }

  .ul li:hover {
    background: #ccc;
    cursor: pointer;
  }

  .ul::-webkit-scrollbar {
    width: 0;
    display: none;
  }

  .xiangmu .h-piece, .h-mrt30 {
    margin: 20px;
  }

  /* .h-formBtnOut  .h-mr20{
      margin-left:0.3rem !important;
  } */

</style>
<style>
  .h-formBox.hidden .h-formBorder .el-input__inner {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cell .h-dialog2 .el-dialog {
    box-shadow: none;
  }

  .h-dialog3.dialogFormVisible3 .el-dialog__body {
    padding: 0 0.5rem 0.3rem 0.5rem;
  }

  .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
    width: 100%;
    height: 103px;
    border: 1px dashed #7c9ec0;
    background: 0;
    line-height: 103px;
    margin-top: 20px;
    color: #4b4b4b;
    font-size: 18px;
  }

  .piliang1 {
    font-size: 18px;
    color: #303030;
    margin-top: 10px;
    margin-left: 10px;
  }

  .piliang2 {
    font-size: 16px;
    color: #919191;
    margin-top: 10px;
    margin-left: 10px;
  }

  .piliangBox {
    display: flex;
    margin-top: 20px;
    align-items: center;

    margin-bottom: 20px;
  }

  .piliangBox .imgs {
    font-size: 16px;
    color: #4b4b4b;
    margin-left: 10px;

  }
  .addDeliveryForm{
    width: 100%
  }
  .clearfix:after{/*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear:both;
    visibility: hidden;
  }
  .clearfix{
    *zoom: 1;/*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
  }

  .addDeliveryForm label {
    padding-right: 20px!important;
  }
  .scoreClass .el-dialog__body {
    padding: 0 0;
  }
</style>
<!--弹窗样式开始-->
<style scoped>
  .commodityMaintenanceBox > .h-piece, .h-mrt30 {
    margin: 20px;
  }

  .h-formBtnOut .h-mr20 {
    margin-left: 3rem !important;
  }

  /deep/ .el-dialog__header {
    padding: 0
  }

  /deep/ .el-dialog {
    border-radius: 0.1rem;
    width: 7.89rem;
  }

  /deep/ .el-dialog__body {
    padding: 0;
  }

  /deep/ .el-dialog__header {
    background: #2785E7
  }

  /deep/ .el-dialog__headerbtn .el-dialog__close {
    height: 0.56rem;
    width: 0.56rem;
    line-height: 0.56rem;
    text-align: center;
    background-color: #fff;
    color: #015ba0;
    border-radius: 100%;
    font-size: 0.34rem;
  }

  .h-dialogImg {
    height: 1.62rem;
    background: url(/img/h-dialogImg.471fa846.png) center no-repeat;
    background-size: 7.89rem;
    padding-left: 4.02rem;
  }

  .h-dialogImg h3 {
    text-align: left;
    padding: .6rem 0 0 0;
    font-size: 0.3rem;
    color: #fff;
    font-weight: normal;
    letter-spacing: 0.02rem;
  }

  .addDeliveryForm {
    padding: 0.54rem 0.28rem 0 0.25rem;
  }

  .addDeliveryForm /deep/ .el-form-item__label {
    width: 84px;
    font-size: 0.18rem;
    color: #4a4a4a;
    line-height: 0.28rem;
    vertical-align: top;
    padding-right: 5px;
    letter-spacing: 0;
    display: inline-block;
    text-align: right;
  }

  .addDeliveryForm /deep/ .el-form-item__content .el-input__inner {
    border-radius: 0;
    background: transparent;
    color: #868686;
    border: 0;
    border-bottom: 1px solid #dedede;
    height: 0.29rem;
    line-height: 0.28rem;
    padding-left: 0.15rem;
  }
</style>
<!--弹窗样式结束-->


